import { SignIn } from '@clerk/react';
import { clerkAppearance } from '../../theme/clerk-appearance';
import { AuthLayout } from './auth-layout';

export function SignInPage() {
  return (
    <AuthLayout>
      <SignIn appearance={clerkAppearance} />
    </AuthLayout>
  );
}
